import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postSummaryExport } from '../../requests/postSummary';

export const useSummaryExport = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: exportSummary, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      identifier,
      data,
    }: {
      uuid?: string;
      identifier?: string;
      data?: any;
    }) =>
      postSummaryExport(constructPost, definitionName, uuid, identifier, data),
  });

  return { exportSummary, ...rest };
};
